module.exports = function() {
  return new Worker(__webpack_public_path__ + "c6a6f12f84751c28b0d2.worker.js");
};